import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class ExcelDumpDashboardService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getAllKeys(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_DUMP.GET_ALL_KEYS}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getExcelDump(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.EXCEL_DUMP.GET_EXCEL_DUMP}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
